var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.customButton
        ? _vm._t("customButton")
        : _c(
            "button",
            {
              staticClass:
                "btn border btn-block dropdown-toggle d-flex justify-content-between align-items-center",
              attrs: { id: `submenu-${_vm.id}`, "data-toggle": "dropdown" },
              on: {
                click: function ($event) {
                  return _vm.$emit("click")
                },
              },
            },
            [
              _c("div", [_c("span", [_vm._v(_vm._s(_vm.label))])]),
              _c("i", {
                staticClass: "far fa-times fa-1x",
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove")
                  },
                },
              }),
            ]
          ),
      _vm._t("menu"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }